module.exports = __webpack_public_path__ + "static/media/ac_th.ff9bca5c.png";